import styled from 'styled-components/macro';
import { Container } from '@yme/atoms/grid';
import { ImageStyled } from '@yme/atoms/image';
import { HeroIframeWrapperStyled } from '@yme/molecules/hero-section-youtube/styled';
import { colorBlackTransparent300, colorCoreBlack700, colorCoreWhite1000, HERO_SECTION_BACKGROUND_SECOND, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel1, HeadingLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
export const HeroComponentStyled = styled(FlexWrapper) `
  position: relative;
  padding-bottom: ${INDENT.xs};
  min-height: 154px;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  ${ADAPTIVE.minWidth.tablet} {
    padding-bottom: ${INDENT.sm};
    min-height: 330px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-bottom: ${({ hasSelectorPanel }) => (hasSelectorPanel ? '96px' : INDENT.xl)};
    min-height: 405px;
    max-width: 1920px;
    margin: 0 auto;
  }

  ${HeroIframeWrapperStyled} {
    top: 0;
  }
`;
export const ImageBgStyled = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }

  ${ImageStyled} {
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;
export const ImageMaskStyled = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }
`;
export const TitleStyled = styled(HeadingLevel1) `
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
`;
export const SubtitleStyled = styled(HeadingLevel4) `
  margin-bottom: ${INDENT.xxxxs};
  word-wrap: break-word;
`;
export const DescriptionStyled = styled(RegularTextLevel3) `
  padding: 24px 16px;
  word-wrap: break-word;
  background: ${colorCoreBlack700};
  color: ${colorCoreWhite1000};

  ${ADAPTIVE.minWidth.tablet} {
    background: none;
    margin: 16px 0 0 0;
    padding: 0;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: ${INDENT.sm};
  }
`;
export const HeroSectionContainer = styled(Container) `
  width: 100%;
  ${ADAPTIVE.minWidth.desktopLg} {
    padding-top: 72px;
  }
`;
